import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const createAuthoringLegislation = api(async function createAuthoringLegislation({
    title,
    url,
    description,
    parentId,
}) {
    return mutate(
        gql`
            mutation CreateAuthoringLegislation(
                $title: String!
                $url: String!
                $description: String
                $parentId: String!
            ) {
                createAuthoringLegislation(title: $title, url: $url, description: $description, parentId: $parentId) {
                    legislation {
                        id
                        legacyId
                        redirectId
                        title
                        redirectUrl
                        url
                        description
                    }
                    junction {
                        id
                        legislationId
                        parentId
                    }
                }
            }
        `,
        { title, url, description, parentId },
        { returns: "createAuthoringLegislation" }
    )
})
